import { render, staticRenderFns } from "./msTr.vue?vue&type=template&id=c6c5f028&scoped=true"
import script from "./msTr.vue?vue&type=script&lang=js"
export * from "./msTr.vue?vue&type=script&lang=js"
import style0 from "./msTr.vue?vue&type=style&index=0&id=c6c5f028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c5f028",
  null
  
)

export default component.exports